/**
 * [微企导入订单]
 * @author: Fu Xiaochun
 * @date: 2021-09-01 
 */


 import PropTypes from 'prop-types';
 import { connect } from 'react-redux';
 import { setBreadcrumbPaths } from '@/reducers/home/actions';
import React, { useEffect, useState } from 'react';
import Uploading from './components/Uploading';
import UploadSuccess from './components/UploadSuccess';
import { regFenToYuan } from '@/util/money';
import { Upload, message, Button, Card, Empty,Select } from 'antd';
import * as qiniu from 'qiniu-js';
import { generateFileName } from '@/components/NewUpload/_util';
import http from '@/assets/api/http';
import {getDeliveryExcelImportUrl,importDelivery, getImportDeliveryExcelRate, emportFailDeliveryExcel} from './api';
import styles from './index.module.scss';
 

let timer = null;
let timestamp = new Date().getTime();
 function MicroImportOrder(props){
    const [loadInfo, setLoadInfo] = useState({fileName:'',percent:0});
    const [loadStatus, setLoadStatus] = useState(0); // 0 未上传 1 上传中 2上传成功 3上传失败
    const [successCount, setSuccessCount] = useState(0);
    const [failCount,setFailCount] = useState(0);
    const [epList, setEpList] = useState([]);
    const [amount, setAmount] = useState('');
    const [epInfo, setEpInfo] = useState(null);

    useEffect(()=>{
 
        // 设置面包屑
        props.setBreadcrumbPaths(props.match);

    }, []);

    useEffect(()=>{
        http('/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepUserInfoService.getMepPair').then(
            res=>{
                if(res && res.errCode===0){
                    setEpList(res.result.dataList);
                }
            }
        );
    },[]);
  
    useEffect(()=>{
      return ()=>{clearInterval(timer);};
    },[]);

    const fileDownLoad = ()=>{
      // window.open('https://ps-online-lazypig.phkjian.com/microep_template_20210906.csv');
      window.open('https://ps-online-lazypig.phkjian.com/microep_template_20220209.csv');
    };

    const onSelect = (value)=>{
        http('/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepUserInfoService.getMepPairDetailById',{id:value}).then(
            res=>{
                if(res && res.errCode===0){
                    setAmount(regFenToYuan(res.result.accountBalance));
                    setEpInfo(res.result);
                }
            }
        );
    };

    const failReason = () =>{
        emportFailDeliveryExcel({timestamp}).then(res=>{
          if(res &&res.errCode === 0){
            window.open(res.result);
          }else{
            message.error('下载失败');
          }
        });
      };
    
      const beforeUpload=(file)=>{
        if (file.name && file.name !== '') {
          const tt = file.name.split('.').pop();
          if (tt === 'csv') {
            timestamp = new Date().getTime();
        setLoadInfo({percent:0,fileName:file.name});
        setLoadStatus(1);
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.QiniuUploadTokenMisService.qiNiuImgToken').then(res=>{
          if(res && res.errCode === 0){
            const fileName = generateFileName(file.name);
            const observable = qiniu.upload(file, fileName, res.result,{},{});
            observable.subscribe({
              next(res){
                console.log('next',res);
                // ...
              },
              error(err){
                console.log('err',err);
              },
              complete(res){
                console.log('complete',res);
                if(res){
                  http('/?cmd=com.xqxc.api.pig.mis.biz.platform.QiniuUploadTokenMisService.qiNiuGetUrl',{param:res.key}).then(res=>{
                    if(res && res.errCode===0){
                        // add 2 args
                        console.log(epInfo);
                        importDelivery(
                        {
                          userId:epInfo.id,
                          userName:epInfo.epName,
                          excelUrl:res.result,
                          // 去掉前端对文件名的处理
                          fileName:file.name,
                          timestamp
                        }
                      ).then(res=>{
                        if(res && res.errCode===0){
                          console.log('updateloading');
                          setLoadStatus(2);
                        //   setLoadStatus(1);
                        //   timer = setInterval(()=>{
                        //     getImportDeliveryExcelRate({timestamp}).then(res=>{
                        //       if(res && res.errCode===0){
                        //         // loading
                        //           if(res.result.rate ===100){
                        //             clearInterval(timer);
                        //             message.success('上传成功');
                        //             setSuccessCount(res.result.successNum);
                        //             setFailCount(res.result.failNum);
                        //             setLoadStatus(2); 
                        //           }
                        //           setLoadInfo({percent:res.result.rate,fileName:file.name});
    
                        //       }else{
                        //         clearInterval(timer);
                        //         message.error('上传失败');
                        //         // message.error(res.errDesc);
                        //         // setLoadStatus(3);
                        //       }
                        //     });
                        //   },400);
                        // }else{
                        //   message.error('上传错误');
                        //   message.error(res.errDesc);
                        //   setLoadStatus(3); 
                        }
                      }).catch((e)=>{
                        // console.log('EEE',e);
                        setLoadStatus(3); 
                      });
                    }
                  });
                }
              }
            }); // 上传开始
            
          }
        });
          }else{
            message.error('不支持此格式文件上传， 请下载模板进行导入数据');
            return false;
          }
        }
        
      };
 

     
      return (
        <div className={styles.excelPage}>
          <Card className={styles.title}>
            <div className={styles.titleHead}>微企订单导入</div>
            <div className={styles.titleList}>
              1、下载批量导入订单模板
              <div onClick={fileDownLoad} className={styles.download} >下载</div>
            </div>
            <div className={styles.titleList}>2、在模板中填写信息 </div>
            <div className={styles.titleList}>3、选择文件上传 </div>
            <div className={styles.showAmount}>
                <div>
                <Select allowClear style={{ minWidth: 120, marginLeft: 20 }} onChange={onSelect}>
                 {epList.map(item=>
                    <Select.Option key={item.id} value={item.id}>{item.epName}</Select.Option>
                    )} 
              </Select>
                </div>
              
              {/* <div className={styles.amount}>￥{amount}</div> */}
              <div>
              <Upload
                beforeUpload={beforeUpload}
                showUploadList={false}
              >
                <Button className={styles.upload}>上传文件</Button>
              </Upload>
              </div>
              
            </div>
          </Card>
          <Card className={styles.content}>
            {loadStatus===0 && <Empty description="暂无订单，快去上传" /> }
            {loadStatus===1 && <Uploading loadInfo={loadInfo} />}
            {loadStatus===2 && <UploadSuccess successCount={successCount} failCount={failCount} failReason={failReason} />}
            {loadStatus===3 && <Empty description="上传失败,请检查后重新上传" />}
          </Card>
        </div>
      );
 }
 
 MicroImportOrder.propTypes = {
     history: PropTypes.object,//路由对象
     match: PropTypes.object, // 路由match对象
     setBreadcrumbPaths: PropTypes.func
 };
 
 export default connect(null, { setBreadcrumbPaths })(MicroImportOrder);